import { render, staticRenderFns } from "./StateTag.vue?vue&type=template&id=9be6dbc0&scoped=true"
import script from "./StateTag.vue?vue&type=script&lang=js"
export * from "./StateTag.vue?vue&type=script&lang=js"
import style0 from "./StateTag.vue?vue&type=style&index=0&id=9be6dbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be6dbc0",
  null
  
)

export default component.exports